'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven(response, note, at) {
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_response = null;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_note = null;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_at = null;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_response = response;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_note = note;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_at = at;
}
export { $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven as $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven };
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven as $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven };
$h_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-480420019), true);
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven)) {
    var x = this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_response;
    var x$2 = x$0.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_response;
    if (((x === x$2) && (this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_note === x$0.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_note))) {
      var x$3 = this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_at;
      var x$4 = x$0.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_at;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.productPrefix__T = (function() {
  return "ResponseGiven";
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_response;
      break;
    }
    case 1: {
      return this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_note;
      break;
    }
    case 2: {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(this.Lapp_api_DrugRequestPharmacyState$ResponseGiven__f_at);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "response";
      break;
    }
    case 1: {
      return "note";
      break;
    }
    case 2: {
      return "at";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DrugRequestPharmacyState$ResponseGiven(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestPharmacyState$ResponseGiven)));
}
export { $isArrayOf_Lapp_api_DrugRequestPharmacyState$ResponseGiven as $isArrayOf_Lapp_api_DrugRequestPharmacyState$ResponseGiven };
var $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ResponseGiven, "app.api.DrugRequestPharmacyState$ResponseGiven", ({
  Lapp_api_DrugRequestPharmacyState$ResponseGiven: 1,
  Lapp_api_DrugRequestPharmacyState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven as $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Response-Given.js.map
